import React from 'react';

const Learning = () => <div>learning</div>;

export default Learning;
